/**
 * Shared Authentication Screen Component
 * Premium design with unified styling
 */

// src/components/shared/AuthScreen.js
import React from 'react';
import { Lock, AlertCircle } from 'lucide-react';

const AuthScreen = ({
  auth,
  title = "LEAD MAGNATE",
  subtitle = "Admin Dashboard",
  error = null,
  theme = "red" // "red" (default) or "blue" (schoorsteenveger)
}) => {
  const {
    password,
    setPassword,
    authError,
    handlePasswordSubmit,
    handleKeyPress,
    authType,
    loading
  } = auth;

  const themeClass = theme === 'blue' ? 'theme-blue' : '';

  return (
    <div className={`auth-screen ${themeClass}`}>
      <div className="auth-card animate-fade-in">
        {/* Header */}
        <div>
          <h1 className="auth-title">{title}</h1>
          <p className="auth-subtitle">{subtitle}</p>

          {error && (
            <div className="auth-error">
              <AlertCircle className="w-4 h-4" />
              {error}
            </div>
          )}
        </div>

        {/* Form */}
        <div className="auth-form">
          <div className="mb-4">
            <label className="auth-label">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-password"
              placeholder={`Enter ${authType} password`}
              onKeyPress={handleKeyPress}
              disabled={loading}
              autoFocus
            />
          </div>

          {authError && (
            <div className="auth-error mb-4">
              <AlertCircle className="w-4 h-4" />
              {authError}
            </div>
          )}

          <button
            onClick={handlePasswordSubmit}
            disabled={loading}
            className="btn btn-primary w-full btn-lg"
          >
            <Lock className="w-4 h-4" />
            {loading ? 'Checking...' : `Access ${subtitle}`}
          </button>
        </div>

        {/* Footer */}
        <div className="auth-footer">
          Powered by{' '}
          <a
            href="https://cookies.nl"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            COOKIES BV
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
